
const formSubmitDelay = 100 // ms

let wrapperEl
let formEl
let formChangeTimeout

function init()
{
    if ((wrapperEl = document.querySelector('.title-and-options')) &&
        (formEl = wrapperEl.querySelector('form')))
    {
        formEl.addEventListener('change', onFormChange)
    }
}

function onFormChange (event)
{
    event.preventDefault()
    clearTimeout(formChangeTimeout)
    formChangeTimeout = setTimeout(() => {
        wrapperEl.classList.add('disabled')
        formEl.submit()
    }, formSubmitDelay)
}


document.addEventListener('DOMContentLoaded', () => {
    init()
})
